<template>
  <base-content>
    <template v-slot:top>
      <hero-header heading="Complaints Policy" />
    </template>
    <p>
      If you feel dissatisfied with any aspect of our service, then in the first instance please contact
      <a href="mailto:compliance@saxontrust.com">compliance@saxontrust.com</a>. We will immediately carry out an
      independent investigation of your complaint and will provide a written response.
    </p>
    <p>
      If we cannot resolve your complaint within three business days, we will refer your complaint to our principal firm,
      Capital Plus Partners Limited, to complete and communicate the outcome of the investigation to you.
    </p>
    <p>
      If we are unable to resolve your complaint to your satisfaction, and you are an eligible complainant as defined by
      the Financial Conduct Authority, you will have recourse to the Financial Ombudsman Service. Details of the
      Financial Ombudsman Service are:
    </p>
    <address>
      <p>
        <strong>The Financial Ombudsman Service</strong><br>
        Exchange Tower<br>
        London E14 9SR
      </p>
      <p>
        <a href="mailto:complaint.info@financial-ombudsman.org.uk">complaint.info@financial-ombudsman.org.uk</a>
      </p>
      <p>
        <a href="tel:02079641000">020 7964 1000</a> (switchboard)<br>
        <a href="tel:+442079641000">+44 20 7964 1000</a> (for calls from outside the UK)<br>
        <a href="tel:02079641001">020 7964 1001</a> (main fax)
      </p>
      <p>
        <a href="tel:08000234567">0800 023 4 567</a><br>
        Calls to this number is now free on mobile phones and landlines.
      </p>
      <p>
        <a href="tel:03001239123">0300 123 9 123</a><br>
        Calls to this number cost no more than calls to 01 and 02 numbers
      </p>
    </address>
  </base-content>
</template>

<script>
import HeroHeader from '@/components/HeroHeader.vue'

export default {
  components: {
    HeroHeader
  }
}
</script>
